<template>
  <div id="app">
    <Player />
<!--    <ParkingDashboard />-->
  </div>
</template>

<script>
import Player from "./components/Player.vue";
import ParkingDashboard from './components/ParkingDashboard.vue';

export default {
  name: "app",
  components: {
    Player,
    ParkingDashboard
  },
};
</script>
